import { Link } from 'react-router-dom';
import { Grid } from "@mui/material";
import { Button } from "@mui/material";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EastIcon from '@mui/icons-material/East';

const Profile = (props :any) => {

  const profileList = [{
    sub: "FAN MARK",
    data: "🌸🤍"
  },{
    sub: "FAN NAME",
    data: "かなみんてぃあ"
  },{
    sub: "あいさつ",
    data: "はろわー, おつかなみ"
  },{
    sub: "誕生日",
    data: "7月3日"
  },{
    sub: "すきなこと",
    data: "歌、ホラーゲーム、お絵描き"
  }];

  const tagList = [{
    sub: "ALL",
    data: "#花波のはなうた"
  },{
    sub: "FAN ART",
    data: "#花波のはなたば"
  },{
    sub: "配信",
    data: "#花波アクセス中"
  },];

  return (
    <div className='content-wrap'>
      <Grid container spacing={0} sx={{width: '100%'}}>
        <Grid size={{xs:12, md:6}}>
          <div className='title'>-PROFILE-</div>
          <div className='link-wrap'>
            <div>
              <a href="https://x.com/kanami_k73" className="flowbtn my_x1">
                <i className="fa-brands fa-x-twitter"></i>
              </a>
            </div>
            <div>
              <a href="https://www.youtube.com/@kanami-channel" className="flowbtn my_youtube1">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
            <div>
              <a href="https://raidori.com/@kanami_k73" className="flowbtn fanclub">
                <div>FAN</div>
                <div>CLUB</div>
              </a>
            </div>
            <div>
              <a href="https://gi-pt.com/main/wishlist/fan-view/3a167edc-c5be-4afc-858b-e7268cd7df69" className="flowbtn gift">
                <CardGiftcardIcon/>
              </a>
            </div>
          </div>
          <div className='profile-list list-wrap'>
            {profileList.map((item, index) => (
              <div className='list-item' key={index}>
                <div>{item.sub}</div>
                <div>{item.data}</div>
              </div>
            ))}
          </div>
        </Grid>
        <Grid size={{xs:12, md:6}}>
          <div className='title'>-TAGS-</div>
          <div className='profile-list list-wrap'>
            {tagList.map((item, index) => (
              <div className='list-item' key={index}>
                <div>{item.sub}</div>
                <div>{item.data}</div>
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
      <Link to="/profile#profile-page">
        <Button variant="contained" className="more-button">
          <div className="label">
            View more
            <EastIcon className="icon"/>
          </div>
        </Button>
      </Link>
    </div>
  );
};

export default Profile;